
<template functional>
    <!-- <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span>COPYRIGHT @ {{ new Date().getFullYear() }} WalletFlo, All rights Reserved</span>
    </footer> -->
     <footer class="" :class="classes">
        <!-- <span>COPYRIGHT @ {{ new Date().getFullYear() }} WalletFlo, All rights Reserved</span> -->
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
